import { ValidateInventoryResponse } from '@/core/domain/inventory/inventories/Inventory.types';
import { Modal, ModalProps, Table, Alert } from 'antd';

interface Props extends ModalProps {
  data?: ValidateInventoryResponse;
}

export default function InventoryLessCountedThanReservedModal({
  data,
  ...props
}: Props) {
  const columns = [
    {
      title: 'Item',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Qtd. Contada',
      dataIndex: 'countedQuantity',
      key: 'countedQuantity',
    },
    {
      title: 'Qtd. Reservada',
      dataIndex: 'totalReservedQuantity',
      key: 'totalReservedQuantity',
    },
  ];

  return (
    <Modal
      {...props}
      title="Pendências de Inventário"
      width={800}
      footer={null}
    >
      {!!data?.itemsWithLessCountedThanReserved.length && (
        <Alert
          type="warning"
          showIcon
          message="Verifique as pendências. Os itens marcados devem ter a quantidade contada igual ou superior à quantidade reservada."
          style={{ marginBottom: 16 }}
        />
      )}

      {!data?.hasAtLeastOneCheckedItem && (
        <Alert
          type="warning"
          showIcon
          message="Para finalizar o inventário, é necessário ter pelo menos um item marcado."
          style={{ marginBottom: 16 }}
        />
      )}

      <Table
        columns={columns}
        dataSource={data?.itemsWithLessCountedThanReserved}
        rowKey="name"
        pagination={false}
      />
    </Modal>
  );
}
